import { IClipboardService } from ".";

export interface IClipboardServiceOwnable {
  getClipboardService(): IClipboardService;
}

export function instanceOfIClipboardServiceOwnable(instance: any): instance is IClipboardServiceOwnable {
  return instance
    && (instance.getClipboardService !== undefined);
}

